module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_8019.21e3cbc6.png";